import React from 'react';
import "swagger-ui/dist/swagger-ui.css";
// import SwaggerUI from 'swagger-ui'
class Swagger extends React.Component {

  componentDidMount() {
	  window.SwaggerUI({
		  dom_id: '#swagger',
		  url: this.props.url,
      spec: this.props.spec,
      supportedSubmitMethods: [],
      defaultModelsExpandDepth: -1
    });
	}
	render() {
	  return <div id="swagger" />
	}
}

export default Swagger;
